import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdaEditComponent } from './pda-edit.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AutoResizeInputDirective } from 'src/app/shared/helpers/auto-resize-input.directive';
import { CommHistoryModule } from "src/app/shared/components/comm-history/comm-history.module";
import { PdaEditRoutingModule } from './pda-edit-routing.module';



@NgModule({
  declarations: [
    PdaEditComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    AutoResizeInputDirective,
    CommHistoryModule,
    PdaEditRoutingModule
]
})
export class PdaEditModule { }
